// Status tone shared by the dashboard and the invoice editor (docs/ui_redesign/02-status-model-and-queues.md).
export const isRejected = s => s >= 80 && s <= 160 && s % 20 === 0;

export function statusTone(statusId) {
	const s = Number(statusId);
	if (s === 180 || isRejected(s)) return 'bad';
	if (s < 40 || s === 40 || s === 41 || s === 60) return 'warn';
	if (s === 170) return 'neutral';
	return 'info';
}
